import type { Lang } from "@/i18n";

export const SITE = {
  name: "2AM Hospitality",
  url: "https://2amhospitality.com",
  email: "hello@2amhospitality.com",
  phone: "+32 479 89 52 15",
  phoneRaw: "+32479895215",
  address: {
    street: "Rue du Pachy 6",
    postal: "1315",
    city: "Incourt",
    country: "BE",
  },
  linkedin: "https://www.linkedin.com/in/alexandre-dufrene-52b16043/",
  // <!-- TODO: replace with real Calendly URL -->
  calendly: "https://calendly.com/2amhospitality",
  founder: "Alexandre Dufrene",
};

// Maps a logical page key to its localized URL path
type PageKey = "home" | "services" | "references" | "about" | "faq" | "tools" | "contact";

const PATHS: Record<Lang, Record<PageKey, string>> = {
  fr: {
    home: "/",
    services: "/services",
    references: "/references",
    about: "/a-propos",
    faq: "/faq",
    tools: "/outils",
    contact: "/contact",
  },
  en: {
    home: "/en",
    services: "/en/services",
    references: "/en/references",
    about: "/en/about",
    faq: "/en/faq",
    tools: "/en/tools",
    contact: "/en/contact",
  },
  nl: {
    home: "/nl",
    services: "/nl/diensten",
    references: "/nl/referenties",
    about: "/nl/over-ons",
    faq: "/nl/faq",
    tools: "/nl/tools",
    contact: "/nl/contact",
  },
};

export function path(lang: Lang, page: PageKey): string {
  return PATHS[lang][page];
}

export function urlFor(lang: Lang, page: PageKey): string {
  return `${SITE.url}${PATHS[lang][page]}`;
}

export function detectLangFromPath(pathname: string): Lang {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname === "/nl" || pathname.startsWith("/nl/")) return "nl";
  return "fr";
}

export function getPageKey(pathname: string, lang: Lang): PageKey {
  const map = PATHS[lang];
  const entry = (Object.entries(map) as [PageKey, string][]).find(([, p]) => p === pathname);
  return entry ? entry[0] : "home";
}

export function alternates(page: PageKey) {
  return {
    fr: urlFor("fr", page),
    en: urlFor("en", page),
    nl: urlFor("nl", page),
  };
}
